import { CommonEditorOption } from '../interface';

export const DEFAULT_EDITOR_OPTION = {
    theme: 'vs-dark',
    fontSize: 14,
    tabSize: 4,
    fontFamily: 'Menlo, Consolas, PingFang SC, Microsoft YaHei, Monaco, Courier New, monospace',
    folding: true,
    minimap: { enabled: false },
    autoIndent: 'advanced',
    contextmenu: true,
    useTabStops: true,
    wordBasedSuggestions: 'currentDocument',
    formatOnPaste: true,
    automaticLayout: true,
    lineNumbers: 'on',
    wordWrap: 'off',
    scrollBeyondLastLine: false,
    fixedOverflowWidgets: false,
    snippetSuggestions: 'top',
    scrollbar: {
        vertical: 'auto',
        horizontal: 'auto',
        verticalScrollbarSize: 10,
        horizontalScrollbarSize: 10
    },
    smoothScrolling: true,
    find: { addExtraSpaceOnTop: false }
} satisfies CommonEditorOption;
